import React from "react";
import { Box, Typography, Link } from "@mui/material";
import Layout from "../Util/Layout";
import UNLEngineering from "../../Assets/UNLEngineering.jpg";
import GeorgiaTech from "../../Assets/GeorgiaTech.png";


const EducationPage = () => {
  return (
    <Layout>
      <Box p={3}>
        <Typography variant="h3" gutterBottom>
          My Education Journey
        </Typography>

        <Typography variant="h5" gutterBottom>
          Georgia Tech
        </Typography>
        <Typography paragraph>
          I am currently a part-time graduate student at Georgia Tech pursuing a
          <strong> Masters of Computer Science in Interactive Intelligence</strong>. Interactive Intelligence
          is essentially the intersection of machine learning and cognitive science, so I am
          taking courses on AI, ML, cognitive science, and more. If you are interested, you can
          take a look at the degree specialization <Link href="https://omscs.gatech.edu/specialization-interactive-intelligence" target="_blank" rel="noopener noreferrer">here</Link>.
        </Typography>
        <Box my={3}>
          <img
            src={GeorgiaTech}
            alt="GATECH Logo"
            style={{
              maxWidth: "70%",
              height: "auto",
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          />
        </Box>
        <Typography variant="h6" gutterBottom>
          Highlighted Course Work
        </Typography>
        <Typography paragraph>
          <Link href="https://omscs.gatech.edu/cs-7637-knowledge-based-artificial-intelligence-cognitive-systems" target="_blank" rel="noopener noreferrer"><strong>Knowledge Based AI - Georgia Tech</strong></Link>:
          This course is designed to teach students to build AI-Agents that are capable of human level cognition, and use these agents to explore the subject of human cognition.
          It is heavily example and project based, with a course project of designing an agent that can solve <Link href="https://arcprize.org/arc" target="_blank" rel="noopener noreferrer">ARC-AGI</Link> problems.
        </Typography>
        <Typography paragraph>
          <Link href="https://omscs.gatech.edu/cs-7646-machine-learning-trading" target="_blank" rel="noopener noreferrer"><strong>Machine Learning for Trading - Georgia Tech</strong></Link>:
          This course is made up of several projects over the course of the semester that work to develop an agentic ML-based market trading approach. Lectures covered graduate-level economic and machine learning principles
          while projects focused on blending the concepts together. You can find mroe information about the agent I designed here <Link href="/ml-trading-project" target="_blank" rel="noopener noreferrer">here</Link>.
        </Typography>
        <Typography paragraph>
          <Link href="https://omscs.gatech.edu/isye-6501-intro-analytics-modeling" target="_blank" rel="noopener noreferrer"><strong>Introduction to Analytics Modeling - Georgia Tech</strong></Link>:
          This course is a survey of analytics modeling, covering classification, clustering, regression, time series models, variable selection,
          optimization, and simulation, with a strong emphasis on choosing the right model for a real world problem rather than just implementing one.
          The course project asked us to design our own analytics solution to a real world problem before reading how it was actually solved. My
          write-up is available <Link href="/Analytics_final_project.pdf" target="_blank" rel="noopener noreferrer">here</Link>, and I have a full review of the
          course <Link href="/articles/isye%206501:-intro-to-analytics-modeling" target="_blank" rel="noopener noreferrer">here</Link>.
        </Typography>
        <Typography paragraph>
          <Link href="https://omscs.gatech.edu/cs-7650-natural-language-processing" target="_blank" rel="noopener noreferrer"><strong>Natural Language Processing - Georgia Tech</strong></Link>:
          This course covers modern, data-driven NLP, moving from bag-of-words models and classification through language models, semantics,
          modern neural architectures, information retrieval, question answering, and machine translation. The course project was an open-ended
          mini-project, for which I built a Key-Value Memory Network from scratch in PyTorch to answer natural language questions. You can read
          about it <Link href="/kvmn-question-answering" target="_blank" rel="noopener noreferrer">here</Link>, and my full review of the course lives
          <Link href="/articles/cs%207650:-natural-language-processing" target="_blank" rel="noopener noreferrer"> here</Link>.
        </Typography>
        <Typography variant="h5" gutterBottom>
          University of Nebraska-Lincoln
        </Typography>
        <Typography paragraph>
          I received my <strong>Bachelors of Science in Software Engineering</strong> from the
          University of Nebraska-Lincoln in 2024.  My focus area
          was Artificial Intelligence & Machine Learning, including classes such as
          "Artificial Intelligence", "Machine Learning", and "Constraint Processing".
          The degree page can be found <Link href="https://computing.unl.edu/software-engineering/" target="_blank" rel="noopener noreferrer">here</Link>.
        </Typography>
        <Box my={3}>
          <img
            src={UNLEngineering}
            alt="UNL Logo"
            style={{
              maxWidth: "70%",
              height: "auto",
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          />
        </Box>

        <Typography variant="h6" gutterBottom>
          Highlighted Course Work
        </Typography>

        <Typography paragraph>
          <strong>Introduction to Machine Learning - UNL</strong>: This is a survey course of the field of machine learning. Topics included theoretical and empirical analyses of decision trees, artificial neural
          networks, Bayesian classifiers, genetic algorithms, instance-based classifiers and reinforcement learning.
        </Typography>
        <Typography paragraph>
          <strong>Foundations of Constraint Processing - UNL</strong>: This graduate-level course focused on foundations of constraint satisfaction, its basic mechanisms
          (search, backtracking, consistency-checking algorithms, etc), and constraint programming languages. There was a heavy focus on implementing methods outlined in modern research papers.
        </Typography>
      </Box>
    </Layout>
  );
};

export default EducationPage;
